import { AppFormItem, AppFormItemProps, AppBaseSelect, AppBaseSelectProps } from 'components/atoms';

export type SimpleSelectElementProps = AppFormItemProps & AppBaseSelectProps;

export const SimpleSelectElement = ({
    options,
    loading,
    onChange,
    disabled,
    suffixIcon,
    mode,
    open,
    showSearch,
    allowClear,
    onClick,
    onClear,
    placeholder,
    ...restProps
}: SimpleSelectElementProps) => (
    <AppFormItem disabled={disabled} {...restProps}>
        <AppBaseSelect
            options={options}
            loading={loading}
            disabled={disabled}
            onChange={onChange}
            mode={mode}
            suffixIcon={suffixIcon}
            open={open}
            showSearch={showSearch}
            allowClear={allowClear}
            onClick={onClick}
            onClear={onClear}
            placeholder={placeholder}
        />
    </AppFormItem>
);
